import moment from "moment";

const autoFillBiForm = (initialValues, updatingValues) => {
  console.log("hsh", initialValues, updatingValues);

  const age = Math.floor(
    (new Date() -
      new Date(
        updatingValues.Request.Proposal.Proposer.DateofBirth
      ).getTime()) /
      3.15576e10
  );
  const dob = updatingValues.Request.Proposal.Proposer.DateofBirth
  const laName =
    updatingValues.Request.Proposal.Proposer.FirstName +
    " " +
    updatingValues.Request.Proposal.Proposer.MiddleName +
    " " +
    updatingValues.Request.Proposal.Proposer.LastName;
  const currentDate = moment().format("YYYY-MM-DD");
  const gender = updatingValues.Request.Proposal.Proposer.Gender;
  const planNo = updatingValues.Request.Proposal.Plan.PlanNo;
  const policyTerm = updatingValues.Request.Proposal.Plan.PolicyTerm;
  const premiumFrequency =
    updatingValues.Request.Proposal.Plan.PremiumFrequency;
  const premiumProposed = updatingValues.Request.Proposal.Plan.PremiumProposed;
  const premiumTerm = updatingValues.Request.Proposal.Plan.PremiumTerm;
  const sumProposed = updatingValues.Request.Proposal.Plan.SumProposed;

  initialValues = {
    ...initialValues,
    UserID: updatingValues.Request.Proposal.UserID,
    ApplicationNo: updatingValues.Request.Proposal.ApplicationNo,
    Age: age,
    DOB:dob,
    LAName: laName,
    Date: currentDate,
    Gender: gender,
    PlanNo: planNo,
    PolicyTerm: policyTerm,
    PremiumFrequency: premiumFrequency,
    PremiumProposed: premiumProposed,
    PremiumTerm: premiumTerm,
    SumProposed: sumProposed,
  };
 console.log("fileed", initialValues);
return initialValues
};

export default autoFillBiForm;
